{
  "version": 1,
  "asset_id": "347cdb05-6a0a-4442-afd7-85ac3e91a57d",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/347cdb05-6a0a-4442-afd7-85ac3e91a57d/raindrop-log.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/347cdb05-6a0a-4442-afd7-85ac3e91a57d/raindrop-log.mp4",
  "original_filename": "raindrop-log.mp4",
  "size": 6787532,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:14:43Z"
}
